import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTheme } from '@material-ui/core/styles'
import { ToggleButtonGroup, Typography } from '@material-ui/core'

const StyledLabel = styled(Typography)`
  && {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    color: var(--mcg-dark, #002e47);
    margin-bottom: 4px;
  }
`

const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  && {
    border-radius: 4px;
    background: transparent;
    width: ${props => (props.fullWidth ? '100%' : 'auto')};
    display: flex;
    gap: 4px;
    padding: 4px;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 6px;
    background: var(--mcg-bg, #f4f6f8);

    .MuiToggleButtonGroup-grouped {
      border-radius: 4px;
      color: #666;
      border: 0 !important;
      text-transform: none;
      width: ${props => (props.fullWidth ? '100%' : 'auto')};

      &.Mui-selected {
        background: var(--mcg-white, #fff);
        color: #000;
      }

      &:hover {
        background: #e0e0e0;
      }

      &.Mui-selected:hover {
        background: var(--mcg-white, #fff);
      }

      ${props =>
        props.fullWidth &&
        `
        flex: 1;
        max-width: none;
      `}
    }
  }
`

// CoreToggleButtonGroup component
const CoreToggleButtonGroup = ({
  color = 'primary',
  variant = 'outlined',
  disabled = false,
  value: controlledValue,
  onChange,
  exclusive = false,
  fullWidth = false,
  label,
  children,
  ...props
}) => {
  const theme = useTheme()
  const [internalValue, setInternalValue] = useState(null)

  // Determine which value to use (controlled or uncontrolled)
  const currentValue =
    controlledValue !== undefined ? controlledValue : internalValue

  // Handle change event
  const handleChange = (event, newValue) => {
    // If the component is uncontrolled, update internal state
    if (controlledValue === undefined) {
      setInternalValue(newValue)
    }

    // Call onChange prop if provided
    if (onChange) {
      onChange(event, newValue)
    }
  }

  return (
    <div>
      {label && <StyledLabel>{label}</StyledLabel>}
      <StyledToggleButtonGroup
        theme={theme}
        color={color}
        disabled={disabled}
        exclusive={exclusive}
        value={currentValue}
        onChange={handleChange}
        fullWidth={fullWidth}
        {...props}
      >
        {children}
      </StyledToggleButtonGroup>
    </div>
  )
}

// Prop validation
CoreToggleButtonGroup.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf([
    'inherit',
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
  ]),
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  exclusive: PropTypes.bool,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
}

export default CoreToggleButtonGroup
